import {useEffect} from "react";

export const OAuthCallback = ({handleOAuthCallback}) => {
    useEffect(() => {
        handleOAuthCallback()
    }, []);
    return null;
};